import { Box, Dialog, Icon, Link, Stack, Typography } from '@liscio/ui';

import PSPDFKitViewer from 'components/PSPDFKit/PSPDFKitViewer';
import { defaultToolbarItems } from 'components/PSPDFKit/toolbarItems';

type RequestPdfDialogProps = {
  open: boolean;
  url: string;
  title: string;
  /** Shown above the viewer with an "Open in new tab" fallback link. */
  notice?: string;
  onClose: () => void;
};

/**
 * Dialog to display a PDF viewer.
 */
export const RequestPdfDialog = ({
  open,
  url,
  title,
  notice,
  onClose,
}: RequestPdfDialogProps) => {
  return (
    <Dialog
      open={open}
      fullScreen
      onClose={onClose}
      title={title}
      iconClose
      PaperProps={{
        sx: {
          width: '98vw',
          maxHeight: '98vh',
        },
      }}
    >
      {notice && <PdfNotice notice={notice} url={url} />}
      <Box height="100%" width="100%" position="relative">
        <PSPDFKitViewer toolbarItems={defaultToolbarItems} url={url} />
      </Box>
    </Dialog>
  );
};

function PdfNotice({ notice, url }: { notice: string; url: string }) {
  return (
    <Stack sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}>
      {/* body2 is bold in some themes; keep the notice regular on every screen. */}
      <Typography variant="body2" sx={{ fontWeight: 'fontWeightRegular' }}>
        {notice}
      </Typography>
      <Link
        component="button"
        sx={{ alignSelf: 'flex-start' }}
        onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
      >
        <Icon icon="download" fontSize="small" /> Open in new tab
      </Link>
    </Stack>
  );
}
